var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTechnicallyValuableOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.1016L14.9858 13.8658C14.7572 14.2587 14.9429 14.5801 15.4 14.5801H16.6072C17.0572 14.5801 17.2429 14.9016 17.0215 15.2944L16.0072 17.0587",
    stroke: "#A5BAB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4786 21.7439V20.6367C10.3 19.3225 8.5 16.7367 8.5 14.0082C8.5 9.30103 12.8214 5.60817 17.7143 6.6796C19.8643 7.15103 21.7429 8.5796 22.7214 10.551C24.7071 14.5439 22.6214 18.7867 19.55 20.6367V21.7439C19.55 22.0225 19.6571 22.6582 18.6357 22.6582H13.3929C12.35 22.6582 12.4786 22.251 12.4786 21.7439Z",
    stroke: "#A5BAB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6711 25.5081C14.8426 24.8866 17.1497 24.8866 19.3283 25.5081",
    stroke: "#A5BAB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 1H11.5C5.70101 1 1 5.70101 1 11.5V20.5C1 26.299 5.70101 31 11.5 31H20.5C26.299 31 31 26.299 31 20.5V11.5C31 5.70101 26.299 1 20.5 1Z",
    stroke: "#A5BAB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicallyValuableOff);
export default __webpack_public_path__ + "static/media/technically_valuable_off.de4c906359f27411d52a668b30f09782.svg";
export { ForwardRef as ReactComponent };